<template>
  <div class="flex justify-center bg-gray-300 h-dvh">
    <!-- login container -->
    <div class="flex w-1/2">
      <!-- form -->

      <div class="items-center px-16 text-left w-full md:px-169">
        <div class="flex pt-2 text-left">
          <img src="" alt="" />
          <div class="flex my-20 text-red-800">
            <svg
              width="50"
              height="53"
              viewBox="0 0 50 53"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.2536 11.6243C20.5581 7.70479 25.597 5.90168 31.3896 6.23417C37.2843 6.57305 41.9529 9.30969 45.9317 13.7663C47.3431 12.2509 48.6204 10.8762 49.9935 9.4056C49.8594 9.23296 49.7125 9.06032 49.572 8.89408L48.6459 9.12426L48.8503 8.06285C46.0977 5.04488 42.649 2.85813 38.9193 1.53456L37.8974 2.85173L38.1784 1.29159C35.5791 0.447581 32.8649 0.019182 30.157 0L29.7546 1.88623L29.0393 0.012788C25.8397 0.12788 22.6848 0.818434 19.8108 2.09724C19.6959 2.14839 19.5873 2.21233 19.4787 2.26348L19.5873 3.46556L18.7635 2.6727L14.0247 5.73543L15.7618 10.3455C15.8767 10.7739 16.0364 11.1959 16.2408 11.6115L16.2536 11.6243Z"
                fill="#FF3839"
              />
              <path
                d="M23.0426 9.96828C21.3246 10.7867 20.1495 11.4964 19.3767 12.2573V12.1422L17.2053 13.7216L19.9196 19.4378C19.9387 19.4698 19.9515 19.5018 19.9771 19.5465C25.9165 12.2957 34.8704 13.2612 39.7242 19.2012C41.1803 17.8201 42.63 16.4454 44.0542 15.0899C39.2452 8.5488 30.4062 6.46435 23.0426 9.96828Z"
                fill="#FF3839"
              />
              <path
                d="M44.7758 40.5061C40.7204 44.6814 35.8028 46.7914 29.9975 46.8106C24.0963 46.8298 19.2617 44.3873 15.0211 40.1864C13.7055 41.7849 12.5112 43.2364 11.2339 44.7901C11.3808 44.9563 11.5341 45.1162 11.6873 45.276L12.5942 44.9883L12.4537 46.0561C15.3851 48.9014 18.9616 50.8708 22.7679 51.9642L23.7067 50.5895L23.5215 52.1688C26.1656 52.8402 28.9054 53.1023 31.6069 52.9553L31.8942 51.0498L32.7181 52.8721C35.905 52.5588 39.0088 51.6828 41.7997 50.225C41.9147 50.1675 42.0169 50.0971 42.1191 50.0332L41.9338 48.8439L42.8024 49.5856L47.3432 46.2351L45.3251 41.7401C45.1846 41.3181 44.9994 40.9089 44.7695 40.5061H44.7758Z"
                fill="#FF3839"
              />
              <path
                d="M20.8903 34.3806C19.5236 35.8512 18.1568 37.3155 16.8157 38.7541C22.0207 44.9883 30.9682 46.5293 38.1019 42.5714C39.7688 41.6506 43.6965 38.4664 43.6965 38.4664L40.6374 32.9292C40.6118 32.8972 40.599 32.8652 40.5735 32.8269C35.0875 40.4294 26.0889 40.0137 20.8839 34.3806H20.8903Z"
                fill="#FF3839"
              />
              <path
                d="M12.3579 7.13571C10.9593 8.536 9.76501 9.94908 8.76233 11.3622L10.327 12.8456L8.24502 12.1103C6.21411 15.1602 5.02622 18.191 4.43227 21.1066L5.92671 21.9059L4.25983 22.0657C3.69782 25.5569 3.96605 28.8562 4.62387 31.7719L7.95124 31.5353L4.82823 32.6223C5.67764 35.9152 6.98688 38.6646 8.07258 40.57L9.59896 39.2529L8.45577 41.2222C9.32434 42.6673 9.96938 43.4857 9.96938 43.4857L21.7142 26.7973L12.3515 7.13571H12.3579Z"
                fill="#FF3839"
              />
            </svg>

            <p class="m-3 text-2xl text-[#333333]">FreeTalk</p>
          </div>
        </div>
        <h2 class="font-bold text-[#002D74] pb-2 text-4xl">Sign in</h2>
        <p class="text-xl mt-4 text-[#002D74]">
          Don’t have an account?
          <router-link to="/signup" custom v-slot="{ navigate }">
            <a
              href="#"
              class="text-[#1C4532] text-2xl"
              @click="navigate"
              role="link"
              >Create now</a
            >
          </router-link>
        </p>

        <form action="" class="flex flex-col gap-8" @submit.prevent>
          <input
            class="items-center w-full p-2 mt-8 text-black border rounded-xl"
            type="email"
            name="email"
            placeholder="Email"
            required
            v-model="email"
          />
          {{ message }}
          <div class="relative">
            <input
              class="w-full p-2 text-black border rounded-xl"
              type="password"
              name="password"
              placeholder="Password"
              required
              v-model="password"
            />
            {{ message }}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="gray"
              class="absolute -translate-y-1/2 bi bi-eye top-1/2 right-3"
              viewBox="0 0 16 16"
            >
              <path
                d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"
              />
              <path
                d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"
              />
            </svg>
          </div>
          <div class="mt-5 text-xl border-[#002D74] py-4 flex justify-between">
            <a href="#" class="text-[#718096]">Remember me </a>
            <a href="#" class="text-[#1C4532]">Forgot your password?</a>
          </div>
          <button
            type="submit"
            class="bg-[#002D74] rounded-xl text-white py-2 hover:scale-105 duration-300"
            @click="
              usersStore.loginUser(this.email, this.password, this.$router)
            "
          >
            Sign in
          </button>
        </form>

        <div class="grid items-center grid-cols-3 mt-6 text-gray-400">
          <hr class="border-gray-400" />
          <p class="text-sm text-center">OR</p>
          <hr class="border-gray-400" />
        </div>
        <!-- *****************************button google********************** -->
        <button
          class="bg-white border py-2 w-full rounded-xl mt-5 flex justify-center items-center text-sm hover:scale-105 duration-300 text-[#002D74]"
        >
          <svg
            class="mr-3"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 48 48"
            width="25px"
          >
            <path
              fill="#FFC107"
              d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
            />
            <path
              fill="#FF3D00"
              d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
            />
            <path
              fill="#4CAF50"
              d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
            />
            <path
              fill="#1976D2"
              d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
            />
          </svg>
          Login with Google
        </button>
        <!-- *****************************button facebook********************** -->
        <button
          class="bg-white border py-2 w-full rounded-xl mt-5 flex justify-center items-center text-sm hover:scale-105 duration-300 text-[#002D74]"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            class="mr-3"
            width="25px"
          >
            <path
              d="M512 256C512 114.6 397.4 0 256 0S0 114.6 0 256C0 376 82.7 476.8 194.2 504.5V334.2H141.4V256h52.8V222.3c0-87.1 39.4-127.5 125-127.5c16.2 0 44.2 3.2 55.7 6.4V172c-6-.6-16.5-1-29.6-1c-42 0-58.2 15.9-58.2 57.2V256h83.6l-14.4 78.2H287V510.1C413.8 494.8 512 386.9 512 256h0z"
            />
          </svg>
          Login with Facebook
        </button>

        <!-- <div
          class="mt-3 text-xs flex justify-between items-center text-[#002D74]"
        >
          <p>Don't have an account?</p>
          <button
            class="px-5 py-2 duration-300 bg-white border rounded-xl hover:scale-110"
          >
            Register
          </button>
        </div> -->
      </div>
    </div>
    <!-- image -->
    <div class="bg-[#1C4532] w-1/2 items-center py-10 h-full">
      <!-- egjdlrefzmelrkfjnddddddddddddddddddd -->
      <div class="bg-white border rounded-xl mx-60 my-40 px-10 text-[#1C4532]">
        <h1 class="my-10 text-3xl text-left">YOWL COMMUNITY</h1>
        <p class="text-left">
          La liberté d’expression est notre priorité. <br />
          N’existez pas à envoyez
        </p>
        <button
          class="border rounded-xl ml mr-60 my-10 gap-8 px-9 py-1 text-left bg-[#1C4532] text-white"
          height=""
          width=""
        >
          Learn more
        </button>
        <!-- <img
          src="https://images.unsplash.com/photo-1616606103915-dea7be788566?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1887&q=80"
        /> -->
      </div>
      <div class="my-10">
        <h2 class="my-10 text-xl">FreeTALK</h2>
        <p>
          Analyzing previous trends ensures that businesses <br />
          always make the right decision. And as the scale of <br />
          the decision and it’s impact magnifies...
        </p>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import { useUsersStore } from "@/stores/user";
export default {
  name: "Sign-InView",
  components: {},
  setup() {
    const usersStore = useUsersStore();
    return {
      usersStore,
    };
  },
  data: () => ({
    email: "",
    password: "",
    message: "",
  }),
  methods: {
    // loginuser(email, password) {
    //   const requestOptions = {
    //     method: "POST",
    //     headers: {
    //       "content-type": "application/json",
    //     },
    //     body: JSON.stringify({
    //       email: email,
    //       password: password,
    //       // confirme_password: this.confirme,
    //     }),
    //   };
    //   console.log("hello");
    //   fetch("http://0.0.0.0:8000/api/auth/login", requestOptions)
    //     .then((response) => response.json(), console.log("hello,"))
    //     .then((end) => {
    //       // (this.token = end.token),
    //       console.log("status"), /*console.log(end)*/ (this.user = end.user);
    //       // this.$router.push("/suggested");
    //     });
    //   // .catch((error) => console.log(error));
    //   // .catch((error) => (this.message = error.message));
    // },
  },
};
</script>
